<template>
    <div class="person_box animate__animated animate__fadeIn">
        <div class="person">
            <div class="search_box">
                <div class="box_line">
                    <div class="line_input">
                        <div class="input_title">巡检性质</div>
                        <el-select :popper-append-to-body="false" size="small" v-model="searchXz" filterable placeholder="请选择" style="border-radius: 0;">
                            <el-option label="请选择" value></el-option>
                            <el-option v-for="item in paramXz" :key="item.id" :label="item.name" :value="item.name"></el-option>
                        </el-select>
                    </div>
                    <div class="line_input">
                        <div class="input_title">巡检类别</div>
                        <el-select :popper-append-to-body="false" size="small" v-model="searchLb" filterable placeholder="请选择" style="border-radius: 0;">
                            <el-option label="请选择" value></el-option>
                            <el-option v-for="item in paramLb" :key="item.id" :label="item.name" :value="item.name"></el-option>
                        </el-select>
                    </div>
                    <div class="line_input">
                        <div class="input_title">巡检人</div>
                        <input type="text" class="input_box" placeholder="巡检人" v-model="searchXjr" />
                    </div>
                    <div class="line_input">
                        <div class="input_title">处置人</div>
                        <input type="text" class="input_box" placeholder="处置人" v-model="searchCzr" />
                    </div>
                    <div class="line_input">
                        <div class="input_title">状态</div>
                        <el-select :popper-append-to-body="false" size="small" v-model="searchState" filterable placeholder="请选择" style="border-radius: 0;">
                            <!-- 状态位:1-处置人未查看2-处置人已阅,未回复3-处置人已阅,已回复4-处置人已处理,巡检人未验收5-验收未通过,处置人已阅,未回复6-验收未通过,处置人已阅,已回复7-准时整改8-超时整改 -->
                            <el-option label="请选择" value></el-option>
                            <el-option label="处置人未查看" value="1">处置人未查看</el-option>
                            <el-option label="处置人已阅,未回复" value="2">处置人已阅,未回复</el-option>
                            <el-option label="处置人已阅,已回复" value="3">处置人已阅,已回复</el-option>
                            <el-option label="处置人已处理,巡检人未验收" value="4">处置人已处理,巡检人未验收</el-option>
                            <el-option label="验收未通过,处置人已阅,未回复" value="5">验收未通过,处置人已阅,未回复</el-option>
                            <el-option label="验收未通过,处置人已阅,已回复" value="6">验收未通过,处置人已阅,已回复</el-option>
                            <el-option label="准时整改" value="7">准时整改</el-option>
                            <el-option label="超时整改" value="8">超时整改</el-option>
                        </el-select>
                    </div>
                </div>
                <div class="box_line">
                    <div class="line_input">
                        <!-- 0: 一般警告 1: 严重警告 2：书面整改 -->
                        <div class="input_title">等级</div>
                        <el-select :popper-append-to-body="false" size="small" v-model="searchLvl" filterable placeholder="请选择" style="border-radius: 0;">
                            <el-option label="请选择" value></el-option>
                            <el-option label="一般警告" value="0">一般警告</el-option>
                            <el-option label="严重警告" value="1">严重警告</el-option>
                            <el-option label="书面整改" value="2">书面整改</el-option>
                        </el-select>
                    </div>
                    <div class="line_input">
                        <div class="input_title">检查时间</div>
                        <el-date-picker
                            size="small"
                            v-model="searchSignDate"
                            type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width:392px;"
                        ></el-date-picker>
                    </div>
                    <div class="search-btn" style="text-align: center;" @click="fnSearch"><span>搜索</span></div>
                </div>
            </div>
            <div class="cont_list">
                <div class="list_title">
                    <div class="title_item">巡检性质</div>
                    <div class="title_item">类别</div>
                    <div class="title_item">巡检人</div>
                    <div class="title_item">处置人</div>
                    <div class="title_item">状态</div>
                    <div class="title_item">等级</div>
                    <div class="title_item">检查时间</div>
                    <div class="title_item">描述</div>
                    <div class="title_item">处理时间轴</div>
                </div>
                <div class="list_boxes">
                    <div class="list_box">
                        <div v-if="cardData">
                            <div class="box_line" v-for="(item, index) in cardData" :key="index">
                                <div class="list_item" :title="item.check_prop | fnQualityTitle">{{ item.check_prop | fnQuality(10) }}</div>
                                <div class="list_item" :title="item.check_type | fnQualityTitle">{{ item.check_type | fnQuality(10) }}</div>
                                <div class="list_item" :title="item.check_person | fnQualityTitle(1)">{{ item.check_person | fnQuality(10) }}</div>
                                <div class="list_item" :title="item.notify_person | fnQualityTitle(1)">{{ item.notify_person | fnQuality(10) }}</div>
                                <div class="list_item" :title="fnQualityStatus(item.status)">
                                    <span v-if="item.status == 1">处置人未查看</span>
                                    <span v-else-if="item.status == 2">处置人已阅,未回复</span>
                                    <span v-else-if="item.status == 3">处置人已阅,已回复</span>
                                    <span v-else-if="item.status == 4">处置人已处理,巡检人未验收</span>
                                    <span v-else-if="item.status == 5">验收未通过,处置人已阅,未回复</span>
                                    <span v-else-if="item.status == 6">验收未通过,处置人已阅,已回复</span>
                                    <span v-else-if="item.status == 7">准时整改</span>
                                    <span v-else-if="item.status == 8">超时整改</span>
                                    <span v-else-if="item.status == 9">已删除</span>
                                    <span v-else></span>
                                </div>
                                <div class="list_item">
                                    <span v-if="item.level == 0">一般警告</span>
                                    <span v-else-if="item.level == 1">严重警告</span>
                                    <span v-else>书面整改</span>
                                </div>
                                <div class="list_item">{{ item.create_at }}</div>
                                <div class="list_item" :title="item.content">
                                    <span>{{ item.content }}</span>
                                </div>
                                <div class="list_item">
                                    <div>
                                        <div class="search-btn orange" @click="fnOpenTimeLine(item)"><span>查看详情</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="cont_page">
                <el-pagination
                    background
                    class="pagination"
                    :page-sizes="pageSizes"
                    :page-size="pageSize"
                    :current-page="currentPage"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                />
            </div>
            <div class="dialog_addEdit animate__animated animate__fadeIn" v-if="showTimeLineWin">
                <el-dialog :modal="false" title="时间线详情" :visible.sync="showTimeLineWin" center style="text-align: center;">
                    <div class="cont_list" style="height:280px;margin:auto;color:#FFFFFF;width:600px;">
                        <div class="list_boxes" style="width:100%;height:275px;">
                            <div class="list_box" style="width:570px;height:275px;overflow: hidden;">
                                <div style="width:590px;height:100%;overflow-y:auto;margin-left:5%;overflow-x: hidden;margin-top: 3%;">
                                    <el-timeline style="padding:0;width: 100%;">
                                        <el-timeline-item v-for="(item, index) in showTimeLine" :key="index" placement="top" :timestamp="item.create_at">
                                            <el-card>
                                                <p class="timeline_item" v-if="item.personnel_type == 0">
                                                    <span>【处置人】{{ item.name }}:</span>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <span class="timeline_status">({{ fnQualityStatus(item.status) }})</span>
                                                </p>
                                                <p class="timeline_item" v-else>
                                                    <span>【抄送人】{{ item.name }}:</span>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <span class="timeline_status">({{ fnQualityStatus(item.status) }})</span>
                                                </p>
                                                <p class="">{{ item.content }}</p>
                                                <p style="width:90%;height:120px;" v-if="item.img[0]">
                                                    <el-image
                                                        v-for="url in item.img"
                                                        v-show="url"
                                                        :preview-src-list="item.img"
                                                        style="float:left;width:20%;height:100%;margin-right:1%;"
                                                        :key="url"
                                                        :src="url"
                                                        lazy
                                                    ></el-image>
                                                </p>
                                            </el-card>
                                        </el-timeline-item>
                                    </el-timeline>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer" style="">
                        <div class="btn_line" style="margin-top: -2.5%;">
                            <div class="search-btn red" @click="showTimeLineWin = false"><span>关闭</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import request from '@/utils/request';
import APP from '@/utils/base';
import { getUserInfo } from '@/utils/auth';

export default {
    data() {
        return {
            cardData: [],
            searchSignDate: '',
            showTimeLine: [], // 时间线详情弹窗
            showTimeLineWin: false, // 时间线详情弹窗
            paramXz: [], //巡检性质参数
            paramLb: [], //巡检类别
            pageSize: APP.PAGE.LIMIT,
            pageSizes: APP.PAGE.SIZE_OPTION,
            currentPage: APP.PAGE.SKIP_PAGE,
            pageTotal: 0,
            searchLb: '',
            searchXz: '',
            searchXjr: '',
            searchCzr: '',
            searchState: '',
            searchLvl: '',
            serchtime: ''
        };
    },
    created() {
        this.fnGetData({
            page: this.currentPage,
            size: this.pageSize
        });
        this.fngetParam();
    },
    methods: {
        //质量/安全 巡检 status 处理
        fnQualityStatus(type) {
            let str = '';
            switch (type) {
                case 1:
                    str = '处置人未查看';
                    break;
                case 2:
                    str = '处置人已阅,未回复';
                    break;
                case 3:
                    str = '处置人已阅,已回复';
                    break;
                case 4:
                    str = '处置人已处理,巡检人未验收';
                    break;
                case 5:
                    str = '验收未通过,处置人已阅,未回复';
                    break;
                case 6:
                    str = '验收未通过,处置人已阅,已回复';
                    break;
                case 7:
                    str = '准时整改';
                    break;
                case 8:
                    str = '超时整改';
                    break;
            }
            return str;
        },
        fnFormatJson(_data) {
            _data = JSON.parse(_data);

            return _data.join(',');
        },
        fnFormatJsonArr(_data) {
            _data = JSON.parse(_data);
            let _arr = [];
            for (var key in _data) {
                _arr.push(_data[key]);
            }
            return _arr.join(',');
        },
        // 更改分页内容
        handleSizeChange(val) {
            this.pageSize = val;
            this.fnSearch(false);
        },
        // 翻页
        handleCurrentChange(val) {
            this.currentPage = val;
            this.fnSearch(false);
        },
        //获取设备数据
        fnGetData(_obj) {
            request({
                url: '/qualitySafe/getSRecords',
                method: 'GET',
                params: _obj
            })
                .then(res => {
                    this.cardData = res.data.query;
                    this.pageTotal = res.data.count;
                })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
        //获取巡检性质
        fngetParam(_obj) {
            request({
                url: '/qualitySafe/getParamSafe',
                method: 'GET',
                params: _obj
            })
                .then(res => {
                    this.paramXz = res.data.xz;
                    this.paramLb = res.data.lb;
                })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
        // 查看时间线详情
        fnOpenTimeLine(_data) {
            let that = this;
            request({
                url: 'SgetTimeLine',
                method: 'GET',
                params: {
                    manage_id: _data.id
                }
            })
                .then(res => {
                    that.showTimeLine = res.data;
                    that.showTimeLineWin = true;
                })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
        // 搜索
        fnSearch() {
            if (this.searchSignDate) {
                this.serchtime = this.searchSignDate[0] + ',' + this.searchSignDate[1];
            } else {
                this.serchtime = '';
            }
            this.currentPage = APP.PAGE.SKIP_PAGE;
            this.fnGetData(
                {
                    page: this.currentPage,
                    size: this.pageSize,
                    level: this.searchLvl,
                    check_prop: this.searchXz,
                    check_type: this.searchLb,
                    check_person: this.searchXjr,
                    notify_person: this.searchCzr,
                    status: this.searchStatus,
                    create_at: this.serchtime
                },
                res => {
                    this.cardData = res.data.query;
                    this.pageTotal = res.data.count;
                }
            );
        }
    }
};
</script>

<style>
.timeline_item {
    height: 15px;
    font-weight: bold;
}
.member .avatar-uploader {
    display: inline-block;
}
.member .avatar-uploader .el-upload {
    width: 100px;
    height: 100px;
    line-height: 100px;
}
.member .avatar-uploader img {
    width: 100px;
    height: 100px;
}
</style>
<style scoped lang="scss" type="text/scss">
@import '~@/styles/mixin.scss';
.person_box {
    width: 1920px;
    height: 858px;
    position: relative;
    overflow: hidden;
    .person {
        position: absolute;
        left: 0;
        right: -20px;
        top: 0;
        bottom: 0;
        overflow-x: hidden;
        overflow-y: auto;
    }
}
.search_box {
    height: 84px;
    width: 1880px;
    margin-top: 24px;
    margin-left: 20px;
    @include flex-box(space-between, center, column);
    .box_line {
        width: 1880px;
        height: 32px;
        @include flex-box(flex-start, center);
        .line_input {
            min-width: 280px;
            height: 30px;
            margin-right: 10px;
            border-top-right-radius: 1px;
            border-bottom-right-radius: 1px;
            background-color: rgba(49, 88, 128, 0.4);
            @include flex-box(flex-start, center);
            .input_title {
                width: 69px;
                height: 30px;
                font-size: 14px;
                color: #9bf9fc;
                border-radius: 2px;
                background-color: rgba(155, 249, 252, 0.1);
                @include flex-box(center, center);
            }
            .input_box {
                width: 211px;
                height: 30px;
                line-height: 30px;
                padding-left: 15px;
                color: rgba(77, 180, 244, 0.7);
                font-size: 12px;
                border-radius: 2px;
                outline: none;
                background: transparent;
                border: none;
                &::-webkit-input-placeholder {
                    color: rgba(77, 180, 244, 0.7);
                }
                &::-moz-placeholder {
                    /* Mozilla Firefox 19+ */
                    color: rgba(77, 180, 244, 0.7);
                }
                &:-moz-placeholder {
                    /* Mozilla Firefox 4 to 18 */
                    color: rgba(77, 180, 244, 0.7);
                }
                &:-ms-input-placeholder {
                    /* Internet Explorer 10-11 */
                    color: rgba(77, 180, 244, 0.7);
                }
            }
        }
    }
}
.cont_list {
    margin-top: 29px;
    margin-left: 28px;
    width: 1864px;
    height: 625px;
    border-radius: 10px;
    background-color: rgba(29, 68, 149, 0.1);
    .list_title {
        width: 1864px;
        height: 48px;
        background: url(../../../assets/img/per_list_bg.png) no-repeat;
        background-size: 100% 100%;
        @include flex-box(flex-start, center);
        .title_item {
            height: 48px;
            @include flex-box(center, center);
            &:nth-child(1) {
                width: 178px;
                margin: 0 4px 0 40px;
            }
            &:nth-child(2) {
                width: 200px;
                margin-right: 4px;
            }
            &:nth-child(3) {
                width: 190px;
                margin-right: 4px;
            }
            &:nth-child(4) {
                width: 190px;
                margin-right: 4px;
            }
            &:nth-child(5) {
                width: 200px;
                margin-right: 4px;
            }
            &:nth-child(6) {
                width: 190px;
                margin-right: 4px;
            }
            &:nth-child(7) {
                width: 200px;
                margin-right: 4px;
            }
            &:nth-child(8) {
                width: 200px;
                margin-right: 4px;
            }
            &:nth-child(9) {
                width: 204px;
            }
            .select {
                width: 20px;
                height: 20px;
                border: 1px solid #65a6dd;
                border-radius: 2px;
                cursor: pointer;
                @include prefixCss3(transition, border-color 0.2s);
                &:hover {
                    border-color: #409eff;
                }
                &.active {
                    background-color: #409eff;
                    border-color: #409eff;
                    &::after {
                        content: '';
                        display: block;
                        width: 100%;
                        height: 100%;
                        @include set-bg-img('../../../assets/images/icon-yes.png');
                    }
                }
            }
        }
    }
    .list_boxes {
        width: 1864px;
        height: 513px;
        position: relative;
        overflow: hidden;
        .list_box {
            position: absolute;
            left: 0;
            right: -25px;
            top: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
            .box_line {
                width: 1784px;
                height: 70px;
                margin: 7px 0 0 40px;
                font-size: 16px;
                color: #ffffff;
                border-bottom: 1px dashed #1d4495;
                @include flex-box(flex-start, center);
                .list_item {
                    height: 70px;
                    text-align: center;
                    @include flex-box(center, center);
                    &:nth-child(1) {
                        width: 178px;
                        margin-right: 4px;
                    }
                    &:nth-child(2) {
                        width: 200px;
                        margin-right: 4px;
                    }
                    &:nth-child(3) {
                        width: 190px;
                        margin-right: 4px;
                    }
                    &:nth-child(4) {
                        width: 190px;
                        margin-right: 4px;
                    }
                    &:nth-child(5) {
                        width: 200px;
                        margin-right: 4px;
                    }
                    &:nth-child(6) {
                        width: 190px;
                        margin-right: 4px;
                    }
                    &:nth-child(7) {
                        width: 200px;
                        margin-right: 4px;
                        cursor: pointer;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    &:nth-child(8) {
                        width: 200px;
                        margin-right: 4px;
                        cursor: pointer;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    &:nth-child(9) {
                        width: 204px;
                    }
                    img {
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                    }
                    &.green-c {
                        color: #89d340;
                    }
                    &.red-c {
                        color: #df7475;
                    }
                    div {
                        @include flex-box(center, center);
                    }
                    .select {
                        width: 20px;
                        height: 20px;
                        border: 1px solid #65a6dd;
                        border-radius: 2px;
                        cursor: pointer;
                        @include prefixCss3(transition, border-color 0.2s);
                        &:hover {
                            border-color: #409eff;
                        }
                        &.active {
                            background-color: #409eff;
                            border-color: #409eff;
                            &::after {
                                content: '';
                                display: block;
                                width: 100%;
                                height: 100%;
                                @include set-bg-img('../../../assets/images/icon-yes.png');
                            }
                        }
                    }
                }
            }
        }
    }
}
.box_line {
    >>> .el-input__inner {
        width: 211px;
        height: 30px;
        border-radius: 2px;
        border: none;
        color: rgba(77, 180, 244, 0.7);
        background: transparent;
        &::-webkit-input-placeholder {
            color: rgba(77, 180, 244, 0.7);
        }
        &::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: rgba(77, 180, 244, 0.7);
        }
        &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: rgba(77, 180, 244, 0.7);
        }
        &:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: rgba(77, 180, 244, 0.7);
        }
    }
    >>> .el-select {
        .el-input {
            .el-select__caret {
                color: rgba(77, 180, 244, 0.7);
            }
        }
    }
    >>> .el-select-dropdown {
        background-color: rgba(77, 180, 244, 0.2);
        border: 1px solid rgba(77, 180, 244, 1);
    }
    >>> .popper__arrow {
        border-bottom-color: rgba(77, 180, 244, 1) !important;
    }
    >>> .el-select-dropdown__item {
        color: rgba(77, 180, 244, 0.7);
    }
    >>> .el-select-dropdown__item:hover {
        color: #409eff;
    }
    >>> .el-select-dropdown__item.hover {
        color: #409eff;
    }
    >>> .el-input__icon {
        color: rgba(77, 180, 244, 0.7);
    }
    >>> .el-range-input {
        background: transparent;
        &::-webkit-input-placeholder {
            color: rgba(77, 180, 244, 0.7);
        }
        &::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: rgba(77, 180, 244, 0.7);
        }
        &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: rgba(77, 180, 244, 0.7);
        }
        &:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: rgba(77, 180, 244, 0.7);
        }
    }
    >>> .el-range-separator {
        color: rgba(77, 180, 244, 0.7);
    }
}
span {
    width: 100%;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.dialog_addEdit {
    .btn_line {
        @include flex-box(center, center);
    }
    >>> .el-dialog {
        width: 800px;
        height: 500px;
        margin-top: 20vh !important;
        background-color: rgba(9, 17, 32, 1);
        border: 1px solid rgba(58, 116, 221, 1);
    }
    >>> .el-form-item__label {
        color: #4db4f4;
    }
    >>> .el-dialog__title {
        color: #4db4f4;
    }
    >>> .el-dialog__close {
        color: #4db4f4;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/SafetyInspection/safetyInspectionDefault/index.vue